import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { results } from '../data/content';
export function Results() {
  const [primary, ...rest] = results;
  return <section className="bg-brand-950 px-4 py-16 sm:py-24" aria-labelledby="results-title" data-id="element-278" data-mp="1jeu97u9x6nf7">
      <div className="mx-auto max-w-4xl" data-id="element-279" data-mp="1fbxwgk729lj6">
        <div id="results-title" data-id="element-280" data-mp="1feaesygqdxwr">
          <SectionHeading dark eyebrow="The measurable result" title="After using the Deck, you will have:" data-id="element-281" data-mp="1tbp5s7mmudqu" />
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-282" data-mp="1obuj6g9w4abl">
          <div className="col-span-2 rounded-3xl bg-gold px-6 py-6 text-center text-brand-950 sm:col-span-1" data-id="element-283" data-mp="232a2tqmnra7n">
            <p className="font-serif text-6xl font-bold leading-none" data-id="element-284" data-mp="1y2fe9tqcuwpr">{primary.value}</p>
            <p className="mt-2 text-sm font-bold uppercase tracking-wide" data-id="element-285" data-mp="2c1x84niid05z">{primary.label}</p>
          </div>
          {rest.map(r => <div key={r.label} className={`rounded-3xl bg-white/10 px-4 py-6 text-center ${r.value === '1' ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-286" data-mp="274yfk9eht19w">
              <p className="font-serif text-5xl font-bold leading-none text-white" data-id="element-287" data-mp="1r2xdy3t78c0y">{r.value}</p>
              <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-brand-100" data-id="element-288" data-mp="1w0fnnwf1iva0">{r.label}</p>
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] leading-relaxed text-brand-100 sm:text-lg" data-id="element-289" data-mp="251x27acsuowl">
          And if you complete one card per day, you have{' '}
          <strong className="text-white" data-id="element-290" data-mp="29yx7hj1trnmn">30 days of structured practice</strong> available without having to decide
          what to do each day.
        </p>

        <SectionCta dark label="I want my 30-practice system" data-id="element-291" data-mp="2jr31eybn0f4h" />
      </div>
    </section>;
}